import { render, staticRenderFns } from "./PagePeriod.vue?vue&type=template&id=604ddfd4"
import script from "./PagePeriod.vue?vue&type=script&lang=js"
export * from "./PagePeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports